<template>
    <div>
        <div class="wrap-document">
            <p class="title">
                PROFIL PERUSAHAAN PIALANG BERJANGKA <br />
                PT ABI KOMODITI BERJANGKA
            </p>
            <div class="wrap-content">
                <div class="content">
                    <tr>
                        <td><label>Nama</label></td>
                        <td>:</td>
                        <td>PT. ABI KOMODITI BERJANGKA</td>
                    </tr>
                    <tr>
                        <td>Alamat</td>
                        <td>:</td>
                        <td>Menara Rajawali Lt 6 Jl. DR. Ide AnakAgung Gede Agung, Kuningan, KuninganTimur, Kec.Setiabudi, Jakarta Selatan,DKI Jakarta 12950</td>
                    </tr>
                    <tr>
                        <td>No. Telepon</td>
                        <td>:</td>
                        <td>021 - 5761461</td>
                    </tr>
                    <tr>
                        <td>Faksimili</td>
                        <td>:</td>
                        <td>021 - 5761463</td>
                    </tr>
                    <tr>
                        <td>E-mail</td>
                        <td>:</td>
                        <td>info@abicommodity.co.id</td>
                    </tr>
                    <tr>
                        <td>Website</td>
                        <td>:</td>
                        <td>www.abicommodity.co.id</td>
                    </tr>
                </div>

                <div class="content">
                    <p class="sub-content">Susunan Pengurus Perusahaan</p>
                    <div class="sub-content mt-2 mb-1">Direksi</div>
                    <tr>
                        <td><label>Direktur Utama </label></td>
                        <td>: Yudo Hutomo</td>
                    </tr>
                    <tr>
                        <td>Direktur Operasional</td>
                        <td>: Budi Hartanto</td>
                    </tr>
                    <tr>
                        <td>Direktur Kepatuhan</td>
                        <td>: Sri Wahyudi</td>
                    </tr>
                    <div class="sub-content mb-1 mt-2">Dewan Komisaris</div>
                    <tr>
                        <td>Komisaris Utama</td>
                        <td>: Evelyn Moniaga</td>
                    </tr>
                    <tr>
                        <td><label>Komisaris</label></td>
                        <td>: Muh Sultan Fahad Satriansyah</td>
                    </tr>
                </div>

                <div class="content">
                    <p class="sub-content">Susunan Pemegang Saham Perusahaan</p>
                    <ol>
                        <li>Evelyn Moniaga</li>
                        <li>Muh Sultan Fahad Satriansyah</li>
                        <li>Riyan Alimhamzah</li>
                    </ol>
                </div>
                <div class="content">
                    <div class="sub-content">Nomor dan Tanggal Izin Usaha dari Bappebti :</div>
                    <tr>
                        <td style="width: 250px;">NOMOR 001/BAPPEBTI/SI/02/2020</td>
                        <td>Tanggal : 26 Februari 2020</td>
                    </tr>
                </div>

                <div class="content">
                    <div class="sub-content">Nomor dan Tanggal Keanggotaan Bursa Berjangka :</div>
                    <tr>
                        <td style="width: 250px;">No : SPAB/172/BBJ/12/2018</td>
                        <td>Tanggal : 17 Desember 2018</td>
                    </tr>
                    <div class="sub-content">Nomor dan Tanggal Keanggotaan PT Bursa Komoditi dan Derivatif Indonesia :</div>
                    <tr>
                        <td style="width: 250px;">No : 213/SPKB/ICDX/DIR/II/2021</td>
                        <td>Tanggal : 18 Februari 2021</td>
                    </tr>
                </div>

                <div class="content">
                    <div class="sub-content">Nomor dan Tanggal Keanggotaan Lembaga Kliring Berjangka:</div>
                    <tr>
                        <td style="width: 250px;">No : 50/AK-KBI/VI/2019</td>
                        <td>Tanggal : 17 Juni 2019</td>
                    </tr>
                    <div class="sub-content">Nomor dan Tanggal Keanggotaan PT.Indonesia Clearing House :</div>
                    <tr>
                        <td style="width: 250px;">No : 194/SPKK/ICH/II/2021</td>
                        <td>Tanggal : 18 Februari 2021</td>
                    </tr>
                </div>

                <div class="content">
                    <p class="sub-content">Kontrak Berjangka yang diperdagangkan</p>
                    <div class="sub-content">Bursa Komoditi dan Derivatif Indonesia</div>
                    <tr>
                        <td style="width: 250px;">GoFX Forex Contract Mini</td>
                    </tr>
                    <tr>
                        <td style="width: 250px;">GOFX Forex Contract Micro</td>
                    </tr>
                    <tr>
                        <td style="width: 250px;">GOFX Cross Currency COFR</td>
                    </tr>
                    <tr>
                        <td style="width: 250px;">GOFX Cross Currency COFRMic</td>
                    </tr>
                    <tr>
                        <td style="width: 250px;">GOFX Cross Currency COFR</td>
                    </tr>
                    <tr>
                        <td style="width: 250px;">GOFX Cross Currency COFU100</td>
                    </tr>
                    <tr>
                        <td style="width: 250px;">GOFX Cross Currency COFO10</td>
                    </tr>
                    <tr>
                        <td style="width: 250px;">GOFX Gold Contract GOLDUD</td>
                    </tr>
                    <tr>
                        <td style="width: 250px;">GOFX Gold Contract GOLDUDMic</td>
                    </tr>
                </div>
            </div>
        </div>
        <div class="wrap-document">
            <div class="wrap-content">
                <div class="content">
                    <tr>
                        <td>Crude Oil Contract OLE01</td>
                    </tr>
                    <tr>
                        <td>Crude Oil Contract OLE10</td>
                    </tr>
                    <tr>
                        <td>Gold Contract GOL10</td>
                    </tr>
                    <tr>
                        <td>Gold Contract Gold 100</td>
                    </tr>
                    <tr>
                        <td>Gold Contract GOL250</td>
                    </tr>
                </div>

                <div class="content">
                    <p class="sub-content">Biaya secara rinci yang dibebankan kepada Nasabah :</p>
                    Biaya Transaksi (ada di trading Rules masing-masing kontrak)
                </div>
                <div class="content">
                    <p class="sub-content">Nomor atau alamat email jika terjadi keluhan :</p>
                    Hotline pengaduan : 021 - 5761449 <br />
                    Email : compliance@abicommodity.co.id <br />
                </div>
                <div class="content">
                    <p class="sub-content">Sarana penyelesaian perselisihan yang dipergunakan apabila terjadi perselisihan :</p>
                    <ol>
                        <li>Secara musyawarah untuk mencapai mufakat antara Para Pihak;</li>
                        <li>Memanfaatkan sarana penyelesaian perselisihan yang tersedia di Bursa Berjangka(JFX) ;</li>
                        <li>Badan Arbitrase Perdagangan Berjangka Komoditi (BAKTI) berdasarkan Peraturan dan Prosedur BAKTI ;</li>
                        <li>Pengadilan Negeri.....................</li>
                    </ol>
                </div>
                <div class="content">
                    <p class="sub-content">Nama - Nama Wakil Pialang Berjangka yang Bekerja di Perusahaan Pialang Berjangka</p>
                    <ol>
                        <li>Yudo Hutomo</li>
                        <li>Yani Rustiani</li>
                        <li>Rahardja Alimhamzah</li>
                    </ol>
                </div>
                <div class="content">
                    <div class="sub-content">Nama - Nama Wakil Pialang Berjangka untuk melakukan verifikasi untuk penerimaan nasabah:</div>
                    <div class="broker_person">
                        <div>
                            <input type="radio" value="Yudo Hutomo" name="brokerName" v-model="broker_name" @change="setInputBroker" />
                            <span>Yudo Hutomo</span>
                        </div>
                    </div>
                </div>
                <div class="content">
                    <p class="sub-content">Nomor Rekening Terpisah (Segregated Account) Perusahaan Pialang Berjangka : :</p>
                    <div class="sub-content">Bank BCA KCU Sudirman Jakarta</div>
                    <tr>
                        <td>Nomor Rekening IDR</td>
                        <td>: 0353197956</td>
                    </tr>
                    <div class="sub-content mt-1">Bank CIMB Niaga KC Jakarta – Graha CIMB Niaga Jakarta Selatan</div>
                    <tr>
                        <td>Nomor Rekening IDR</td>
                        <td>: 860008133700</td>
                    </tr>
                    <tr>
                        <td>Nomor Rekening USD</td>
                        <td>: 860008134940</td>
                    </tr>
                </div>
            </div>
            <div class="content">
                <p class="title-penutup">PERNYATAAN TELAH MEMBACA PROFIL PERUSAHAAN PIALANG BERJANGKA</p>
                <div class="penutup">
                    <p>
                        Dengan mengisi kolom “YA” di bawah ini, saya menyatakan bahwa saya telah membaca dan menerima informasi
                        <b>PROFIL PERUSAHAAN PIALANG BERJANGKA PT ABI KOMODITI BERJANGKA</b>, mengerti dan memahami isinya
                    </p>
                </div>

                <div class="persetujuan">
                    <div>
                        <p>Pernyataan menerima</p>
                        <div class="pernyataan">
                            <input type="radio" name="confirmProfil" v-model="setValue" :value="true" required @change="handleValue" />
                            <span>Ya</span>

                            <input type="radio" :value="false" v-model="setValue" @change="handleValue" />
                            <span>Tidak</span>
                        </div>
                    </div>
                    <div>
                        <p>Menerima pada Tanggal</p>
                        <form>
                            {{ currentDate | formatDateTime }}
                        </form>
                    </div>
                </div>
                <div class="footer"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        statementProfil: Boolean,
        dataPrint: Object,
    },
    data() {
        return {
            currentDate: "",
            broker_name: "Yudo Hutomo",
        };
    },

    mounted() {
        console.log(this.statementProfil);
        if (this.dataPrint) {
            this.currentDate = this.dataPrint.tanggal_diterima;
        } else {
            this.currentDate = new Date();
        }
    },
    computed: {
        setValue() {
            return this.statementProfil;
        },
    },
    methods: {
        handleValue(e) {
            this.$emit("updateValue", e.target._value);
        },
        setInputBroker() {
            this.$emit("inputBroker", this.broker_name);
        },
    },
};
</script>

<style scoped>
ol,
ul {
    margin-left: 10px;
}

label {
    width: 135px;
    margin-right: 0;
    margin-bottom: 0;
}

/* .wrap-document {
    width: 100%;
    margin: auto;
    padding: 20px;
} */

.wrap-document {
    /* width: 210mm; */
    height: 277mm;
    /* padding: 10mm; */
    margin: 0.5mm auto;
    /* border: 1px red solid; */
    border-radius: 5px;
    background: white;
    /* box-shadow: 0 0 5px rgba(0, 0, 0, 0.1); */
    position: relative;
}

.wrap-content {
    border: solid 1px #4a4a4a;
}

.top {
    display: flex;
    justify-content: space-between;
    font-size: 10px;
}

.header {
    display: flex;
    justify-content: space-between;
    font-size: 10px;
    margin-bottom: 25px;
}

.nomor {
    font-weight: bold;
}

.lampiran p {
    margin: 0;
    text-align: right;
}

.title {
    font-weight: bold;
    text-align: center;
    margin: 0 auto 40px !important;
    font-size: 14px;
}

.title-penutup {
    font-weight: bold;
    text-align: center;
    font-size: 14px;
}

.content {
    font-size: 12px;
    text-align: justify;
    border: inherit;
    padding: 10px;
}

.sub-content {
    font-weight: 700;
}

form {
    margin: 20px 0;
    text-align: right;
    font-weight: 700;
}

.pernyataan span {
    margin: -2px 30px 0 8px;
}

.penutup {
    text-align: center;
    font-size: 12px;
}

.penutup p {
    margin: 0;
}

.resiko {
    font-weight: 700;
}

.broker_person {
    display: flex;
    gap: 3rem;
    margin-top: 1rem;
}

.broker_person input {
    margin-right: 0.5rem;
}

.persetujuan {
    font-size: 12px;
    margin: 1.5rem auto;
    width: 50%;
}

.persetujuan div {
    display: flex;
}

.persetujuan p {
    width: 230px;
    margin-bottom: 0;
}

.persetujuan div form {
    margin: 0;
    font-weight: normal;
}

.tanggal {
    margin-left: auto;
    margin-bottom: 10px !important;
}

.jabatan {
    margin-bottom: 70px !important;
}

.pt-abi {
    display: block !important;
    margin: 20px auto;
    width: 50%;
}

.pt-abi p {
    width: auto !important;
}

.footer {
    display: flex;
    font-size: 10px;
    justify-content: space-between;
}

@media (max-width: 768px) {
    .wrap-document {
        width: 100%;
        padding: 30px 0;
        height: 100%;
    }

    .title {
        margin: 20px auto !important;
    }

    .persetujuan{
        width: 100%;
    }

    .persetujuan p{
        width: 165px;
    }
}
</style>
